import { riskGapUserStatusOptions } from '@ctw/shared/api/fhir/models/risk-gap';
import type { FilterItem } from '@ctw/shared/components/filter-bar/filter-bar-types';
import { faClipboardCheck, faHourglass } from '@fortawesome/pro-duotone-svg-icons';

export const RiskGapFilters: Array<FilterItem> = [
  {
    key: 'type',
    type: 'checkbox',
    icon: faClipboardCheck,
    display: 'Type',
    values: ['recapture', 'suspect'],
  },
  {
    key: 'status',
    type: 'checkbox',
    icon: faHourglass,
    display: 'Status',
    values: riskGapUserStatusOptions.map((option) => option.value),
  },
];
